import styled from "styled-components";
import theme from "../../../../Themes/light";

export const ContainerCriarProduto = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6rem;
  padding: 0rem 12rem;
  width: 150rem;
  max-width: 90vw;

  > .containerImagem {
    min-width: 55%;

    > .imagem {
      width: 100%;
    }
  }

  > .containerTexto {
    min-width: 45%;
    text-align: left;
    color: ${(props) => props.theme.colors.tertiary};

    > span {
      color: ${(props) => props.theme.colors.secondary};
      font-weight: bold;
    }
  }

  @media (max-width: 1024px) {
    padding: 0rem 6rem;
    flex-direction: column;

    .containerImagem {
      width: 100%;

      .imagem {
        max-width: 50rem;
      }
    }

    .containerTexto {
      text-align: center;
    }
  }
`;
